import { AmbientesSection } from '@/modules/home/components/ambientes-section';
import { AtelieSection } from '@/modules/home/components/atelie-section';
import { DepoimentoSection } from '@/modules/home/components/depoimento-section';
import { HeroSection } from '@/modules/home/components/hero-section';
import { OrcamentoSection } from '@/modules/home/components/orcamento-section';
import { ProcessoSection } from '@/modules/home/components/processo-section';
import { ShowroomSection } from '@/modules/home/components/showroom-section';
import { ProjectsSection } from '@/modules/projects/components/projects-section';

/**
 * Página única do site.
 *
 * As seções entram na ordem do protótipo em `legacy/static-site`. Hoje existem
 * o hero, o ateliê, os ambientes, a galeria de projetos — esta já vinda do
 * CMS —, o processo, o depoimento, o showroom e o orçamento. Faltam só os
 * bastidores, que dependem de um vídeo que o cliente não entregou.
 */
export function HomePage() {
  return (
    <>
      <HeroSection />
      <AtelieSection />
      <AmbientesSection />
      <ProjectsSection />
      <ProcessoSection />
      <DepoimentoSection />
      <ShowroomSection />
      <OrcamentoSection />
    </>
  );
}
